import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useCallback } from "react";
import toast from "react-hot-toast";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import { AddUserOfListPatient } from "../../../../services/rest/users/userProviderService";
import { useSelector } from "react-redux";
import { handleError } from "../../../../utils/handleError";

const ModalAddPatient = ({ open, setOpen, setLoading, selectedUser }) => {
  const { _id } = useSelector((state) => state.userReducer);
  const handleClose = useCallback(() => setOpen(false), [setOpen]);
  const addUser = useCallback(async () => {
    try {
      setLoading(true);
      //Hacer peticion a la APi de agregar usuario a lista de pacientes
      //Si se agrego bien hacer peticion a lista de pacientes y lista de usuarios para refrescar redux de listPatients y listAllUsers
      // console.log("Usuario seleccionado", selectedUser);
      await AddUserOfListPatient(
        {
          email: selectedUser?.email,
        },
        _id
      );
      toast.success("Se agrego con éxito a tus pacientes");
      handleClose();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      const { message } = handleError(error);
      toast.error(
        `No pudimos agregar al paciente en estos momentos. \n ${message}`
      );
    }
  }, [handleClose, setLoading, selectedUser]);

  return (
    <Dialog open={open}>
      <DialogContent sx={{ padding: 5 }}>
        <DialogTitle>
          <Typography sx={{ textAlign: "center" }}>
            Deseas agregar a {selectedUser?.firstName} a tu lista de pacientes
          </Typography>
        </DialogTitle>
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="outlined"
            sx={{ borderColor: "white", color: "white" }}
            onClick={handleClose}
            startIcon={<CancelIcon />}
          >
            Cerrar
          </Button>
          <Button
            variant="contained"
            onClick={addUser}
            sx={{ backgroundColor: "#e7ef7d" }}
            startIcon={<PersonAddAltIcon />}
          >
            Agregar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ModalAddPatient;
